const TEXT = {
  PS_NAME: {id: 'lookiero.cross.psname'},
  PS_ROLE: {id: 'lookiero.cross.psjob'},
};

export {TEXT};
